import React, {useEffect, useState, Fragment} from 'react'
import {flatMap, uniq, debounce} from 'lodash'

import {getLocationsAndGroups} from '../../../../services/locations/api';

import './BulkLocationSelector.css'

function BulkLocationSelectorLocationGroup({locationGroup, selected, onClick}) {
  const label = locationGroup.type === "ALL" ? "All Locations": locationGroup.name;
  return <li>
    <div className="custom-control custom-checkbox">
      <input type="checkbox" id={locationGroup.id} className="custom-control-input" onChange={onClick} checked={selected}/>
      <label className="custom-control-label" htmlFor={locationGroup.id}>{" " + label} - {locationGroup.totalLocations}</label>
    </div>
  </li>
}

function BulkLocationSelectorLocation({location, selected, onClick}) {
  const label = location.name;
  return <li>
    <div className="custom-control custom-checkbox">
      <input type="checkbox" id={location.id} className="custom-control-input" onChange={onClick} checked={selected}/>
      <label className="custom-control-label" htmlFor={location.id}>{" " + label}<br />
        {location.address.streetAddress}, {location.address.addressLocality} {location.address.addressRegion}, {location.address.postalCode}
      </label>
    </div>
  </li>
}

/**
 * @param onSelectedLocations - Callback for when locations/groups are selected
 * @param onSearch - What to call when search box is used
 * @param onLoadedLocationsAndGroups - Callback to run when locations/groups are loaded
 */
function BulkLocationSelector ({
                                 loadingLocationSelector,
                                 lockLocationSelector,
                                 onSelectedLocations,
                                 onSearch,
                                 locationsAndGroups,
                                 selectedLocationsAndGroups,
                                 flattenedSelectedLocations}) {

  const categoryState = ["all", "accounts", "groups", "locations"]
    .map(categoryName => {
      return {
        name: categoryName,
        collapsed: false
      }
    });

  const [categories, setCategories] = useState(categoryState);

  // All locations and groups
  const allLocationsAndGroups = locationsAndGroups;

  // Visible locations and groups (filtered by search box)
  const visibleLocationsAndGroups = allLocationsAndGroups;

  const selectLocationGroup = (category, locationGroup) => (event) => {
    const selected = event.target.checked;
    const _selectedLocationsAndGroups = {
      ...selectedLocationsAndGroups,
      [category + "." + locationGroup.id.replace("legacy-", "")]: selected
    }

    let _flattenedSelectedLocations = selected
        ? flattenedSelectedLocations.concat(locationGroup.locations)
        : flattenedSelectedLocations.filter(selectedLocationId => {
          // Deselect all locations that are in the group that are not themselves selected individually
          return !locationGroup.locations.includes(selectedLocationId) || _selectedLocationsAndGroups["locations." + selectedLocationId] === true
        });

    onSelectedLocations(_selectedLocationsAndGroups, uniq(_flattenedSelectedLocations));
  };

  const debouncedSearch = debounce((searchQuery) => {
    onSearch(searchQuery)
  }, 250);

  const onSearchInputChange = (event) => {
    const searchQuery = event.target.value.toLowerCase();
    debouncedSearch(searchQuery);
  };

  const toggleCategory = (categoryName) => {
    setCategories(categories.map(category => {
      return category.name === categoryName ? {...category, collapsed: !category.collapsed} : category
    }));
  };

  return <div className="inner-scroll-container">
    <fieldset disabled={lockLocationSelector}>
    <span className="input-group card-spacer-bottom">
    <input className="form-control"
           type="text"
           placeholder="Name, Address, City, State, ID, Client Location ID"
           onChange={onSearchInputChange}
    />
      <div className="input-group-append">
        <i className="input-group-text far fa-search d-flex"/>
      </div>
    </span>
    {loadingLocationSelector ? <div>
      <div className='card-spacer-top'>
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}} />
      </div>
      <div className='card-spacer-top'>
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}} />
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
      </div>
      <div className='card-spacer-top'>
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
      </div>
      <div className='card-spacer-top'>
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
        <div className='skeleton-text-lg' style={{"maxWidth": "none"}}  />
      </div>
    </div> : <div>{visibleLocationsAndGroups && categories.map(category => {
      const key = category.name;
      const isCategoryCollapsed = category.collapsed;
      if (visibleLocationsAndGroups[key].length > 0) {
      const keyCapitalized = key.charAt(0).toUpperCase() + key.slice(1);
      return <Fragment key={key}>
      {key !== "all" && <div><div
          className="form-group mb-2 card-spacer-top d-flex justify-content-between clickable"
          onClick={() => toggleCategory(key)}
      >
        <h5>
          {keyCapitalized}</h5>
        <i className={"far fa-chevron-down animate-rotate d-flex align-items-center" + (!isCategoryCollapsed ? "" : " rotate-180")} />
      </div></div>}
      {!isCategoryCollapsed && <ol>
        {(visibleLocationsAndGroups[key].length > 0) && visibleLocationsAndGroups[key].map((locationGroup, index) => {
          return category.name === "locations" ?
              <BulkLocationSelectorLocation key={index} location={locationGroup}
                                            selected={selectedLocationsAndGroups[category.name + "." + locationGroup.id.replace("legacy-", "")] === true}
                                            onClick={selectLocationGroup(category.name, locationGroup)}/> :
              <BulkLocationSelectorLocationGroup key={index} locationGroup={locationGroup}
                                                 selected={selectedLocationsAndGroups[category.name + "." + locationGroup.id] === true}
                                                 onClick={selectLocationGroup(category.name, locationGroup)}/>
        })}
      </ol>}
      </Fragment>
    } else {
      return <Fragment key={key} />
    }
    })}{locationsAndGroups.all[0].locations.length > 100 && "Viewing first 100 locations. Use search to find all locations."}</div>}
    </fieldset>
  </div>
}

export default BulkLocationSelector
